<div class="contents-area">
  <div>
    <h1>束ね企画回登録</h1>
    <div class="element-column">
      <div class="block-row">
        <div class="column-list">
          <label class="list-input-title">媒体</label>
          <div class="list-input-content">
            <select id="cmb_MediumType" #cmb_MediumType [tabindex]="0" class="text-label-required"
              [(ngModel)]="kymw7100Model.formData.mediumType" style="width:226px">
              <ng-template ngFor let-item [ngForOf]="kymw7100Model.mediumTypeList">
                <option value="{{item.mediumType}}">{{item.mediumTypeName}}</option>
              </ng-template>
            </select>
          </div>
          <label class="list-input-title">受注コード</label>
          <div class="list-input-content">
            <app-order-text-with-catalog #cmb_StartOrderCode id="cmb_StartOrderCode" [subid]="'cmb_StartOrderCode'"
              [autofocus]="true" [required]="true" [tabindex]="0" [(ngModel)]="kymw7100Model.formData.startOrderCode"
              (onChangedCatalogId)="kymw7100Model.formData.startCatalogId = $event" [forcedEnabledMode]="''"
              width="7rem">
            </app-order-text-with-catalog>
            <label>～</label>
            <app-order-text-with-catalog #cmb_EndOrderCode id="cmb_EndOrderCode" [subid]="'cmb_EndOrderCode'"
              [autofocus]="true" [required]="true" [tabindex]="0" [(ngModel)]="kymw7100Model.formData.endOrderCode"
              (onChangedCatalogId)="kymw7100Model.formData.endCatalogId = $event" [forcedEnabledMode]="''"
              width="7rem">
            </app-order-text-with-catalog>
          </div>
          <label class="list-input-title">企画回</label>
          <div class="list-input-content">
            <app-catalog-text-with-order #cmb_StartCatalogId id="cmb_StartCatalogId" [subid]="'cmb_StartCatalogId'"
              [autofocus]="true" [required]="true" [tabindex]="0" [(ngModel)]="kymw7100Model.formData.startCatalogId"
              (onChangedOrderCode)="kymw7100Model.formData.startOrderCode = $event" [forcedEnabledMode]="''"
              width="7rem">
            </app-catalog-text-with-order>
            <label>～</label>
            <app-catalog-text-with-order #cmb_EndCatalogId id="cmb_EndCatalogId" [subid]="'cmb_EndCatalogId'"
              [autofocus]="true" [required]="true" [tabindex]="0" [(ngModel)]="kymw7100Model.formData.endCatalogId"
              (onChangedOrderCode)="kymw7100Model.formData.endOrderCode = $event" [forcedEnabledMode]="''"
              width="7rem">
            </app-catalog-text-with-order>
          </div>
          <label class="list-input-title">企画回名称</label>
          <div class="list-input-content">
            <div class="element-row">
              <app-not-null-text-input id="tbx_BundleCatalogName" #tbx_BundleCatalogName
                [subid]="'tbx_BundleCatalogName'" [fullOnly]="true" [restrict]="'[ -￮]'" [maxChars]="30" [tabindex]="0"
                [displayCountField]="true" width="32rem" [(ngModel)]="kymw7100Model.formData.bundleCatalogName">
              </app-not-null-text-input>
            </div>
          </div>
          <button [tabindex]="0" id="btn_Register" class="btn-primary" #btn_Register
            (click)="eventRegister_CLICKHandler()">登録</button>
        </div>
      </div>
    </div>
  </div>

  <div>
    <h1>束ね企画回一覧</h1>
    <wj-flex-grid #dtg_BundleCatalogList [itemsSource]="kymw7100Model.bundleCatalogList" [tabindex]="0"
      id="dtg_BundleCatalogList" [headersVisibility]="'Column'" [isReadOnly]="true" [selectionMode]="'Row'"
      [deferResizing]="false" [allowDragging]="'None'">
      <wj-flex-grid-filter #fltr_BundleCatalogList></wj-flex-grid-filter>
      <wj-flex-grid-column [minWidth]="5" [header]="'媒体'" [width]="335" [binding]="'mediumTypeName'"
        [isReadOnly]="true"></wj-flex-grid-column>
      <wj-flex-grid-column [minWidth]="5" [header]="'開始受注コード'" [width]="120" [binding]="'startOrderCode'"
        [isReadOnly]="true" [allowSorting]="false"></wj-flex-grid-column>
      <wj-flex-grid-column [minWidth]="5" [header]="'開始企画回'" [width]="120" [binding]="'startDelivCatalogId'"
        [isReadOnly]="true" [allowSorting]="false"></wj-flex-grid-column>
      <wj-flex-grid-column [minWidth]="5" [header]="'終了受注コード'" [width]="120" [binding]="'endOrderCode'"
        [isReadOnly]="true" [allowSorting]="false"></wj-flex-grid-column>
      <wj-flex-grid-column [minWidth]="5" [header]="'終了企画回'" [width]="120" [binding]="'endDelivCatalogId'"
        [isReadOnly]="true" [allowSorting]="false"></wj-flex-grid-column>
      <wj-flex-grid-column [minWidth]="5" [header]="'名称'" [width]="445" [binding]="'bundleCatalogName'"
        [isReadOnly]="true" [allowSorting]="false"></wj-flex-grid-column>
      <wj-flex-grid-column [minWidth]="5" [header]="'束ね企画回コード'" [width]="150" [binding]="'bundleCatalogCode'"
        [isReadOnly]="true" [allowSorting]="false"></wj-flex-grid-column>
    </wj-flex-grid>
  </div>
</div>
